import { Suspense } from 'react';
import { LoadingSpinner } from '#screens/loading/LoadingSpinner.tsx';
import { page, Titled } from '#util/title.ts';
import { CanonicalizationPreviewPage } from './page/CanonicalizationPreviewPage.tsx';

export function DnsPreviewRoot() {
  return (
    <Titled title={() => page('DNS name preview')}>
      <Suspense fallback={<LoadingSpinner />}>
        <CanonicalizationPreviewPage />
      </Suspense>
    </Titled>
  );
}
